import React from 'react';
import AudioPlayer from '../components/AudioPlayer';
import { withRouter } from 'react-router-dom';
import { AppContext } from '../AppContext';
import "croppie/croppie.css";
import Croppie from "croppie";
import { RecordEvent } from '../Analytics';

const song = "audio/cte_music.mp3";

class Step2IOS extends React.Component {

    constructor(props) {

        super(props);

        this.resize = null;
        
        this.feedback = null;

        this.audioPlayer = new AudioPlayer(null, "playaudio", "play-bar", song);
        
        this.submitPhoto = this.submitPhoto.bind(this);
        this.submitVideo = this.submitVideo.bind(this);
        this.playAudio = this.playAudio.bind(this);
        this.validateVideoFile = this.validateVideoFile.bind(this);
        this.showFile = this.showFile.bind(this);
        this.rotateImg = this.rotateImg.bind(this);
    }

    componentDidMount() {

        this.audioPlayer.init();

        this.feedback = document.getElementById("feedback");

        var c = document.getElementById('item');
        
        if (c) {
            this.resize = new Croppie(c, {
                enableExif: true,
                viewport: {
                    width: 200,
                    height: 267,
                    type: 'square'
                },
                boundary: {
                    width: 240,
                    height: 320
                },
                showZoomer: true,
                enableResize: false,
                enableOrientation: true                
            });
        }
    }

    showFile() {
        var self = this;
        var c = document.getElementById('item');
        var cc = document.getElementById('rotate');
        var next = document.querySelector('.next');
        var file1 = document.querySelector('#file-1');

        if (file1) {

            var file = file1.files[0];
            var change = document.querySelector('.file1-text');
            var reader = new FileReader();

            reader.onload = function (event) {
                self.resize.bind({
                    url: reader.result,
                });

                change.innerHTML = "Change photo";

                document.getElementById("submitPhoto").className="next-button-con next";
            }
            
            c.classList.remove("hidden");
            cc.classList.remove("hidden");
            next.classList.remove("hidden");
        
            reader.readAsDataURL(file);
            console.log(file);
        }
    }

    rotateImg() {
        this.resize.rotate(90);
    }
    
    async validateVideoFile() {
        var self = this;
        var videoFile = document.getElementById("file-2");
        var video = document.getElementById("videoFileOut");
        var labelText = document.getElementById("labelText");
        video.preload = 'metadata';
        
        try {

            if (videoFile.value.split('.').pop().toLowerCase() !== "mov" && videoFile.value.split('.').pop().toLowerCase() !== "mp4") {
                self.feedback.innerHTML = "File format invalid. Must be of video type MOV or MP4.";
                RecordEvent("Error-InvalidExtension");
                return;
            }

            video.onloadedmetadata = function() {
                var duration = video.duration;

                if (isNaN(duration)) {
                    self.feedback.innerHTML = "File format invalid. Must be of video type MOV or MP4.";
                    document.getElementById("submitVideo").className = "hidden";
                    RecordEvent("Error-InvalidVideo");
                } else {
                    
                    if (duration < 40) {
                        document.getElementById("submitVideo").className = "next-button-con next";      
                        self.feedback.innerHTML = "";
                        labelText.innerHTML = "Upload Complete";
                    } else {
                         self.feedback.innerHTML = duration + " is over 30 seconds!";
                         document.getElementById("submitVideo").className = "hidden";   
                         RecordEvent("Error-VideoTooLong");
                    }                    
                }
            }

            video.src = URL.createObjectURL(videoFile.files[0]);

        } catch (error) {
            console.error(error);
            self.feedback.innerHTML = "File format invalid. Must be of video type MOV or MP4.";
            document.getElementById("submitVideo").className = "hidden";
            RecordEvent("Error-VideoTooLong");
        }
    }

    submitPhoto() {
        var self = this;
        this.resize.result({
                type:'blob',
                size: 'original',
                format: 'png'
            }).then(function (blob, original) {
            self.context.image = blob;

            document.getElementById("uploadPhoto").className = "hidden";
            document.getElementById("uploadVideo").className = "";            
        });        
    }

    submitVideo() {
        
        var videoFile = document.getElementById("file-2");
        this.context.video = videoFile.files[0];
        this.props.history.push('step3');
    }

    playAudio() {

        this.audioPlayer.play();
    }

    render() {

        return (
            <div>
                <img src="img/texture1.png" className="backgroundfill" alt=""/>
                <div className="side-menu ">
                    <div className="cover"></div>
                    <div className="step-menu-con">
                        <img src="img/sid-menu-img.png" alt="exsample gif" srcSet="" className="side-menu-top"/>
                        <div className="center-gold"></div>
                        <h1 >thank you lord</h1>
                        <h3>enhanced video</h3>

                        <div className="textcon">
                            <p>Join Chris Tomlin, Thomas Rhett, and Florida Georgia Line in a :25 clip from “Thank You Lord”!</p>
                            <div className="center-gold"></div>
                        </div>

                        <div className="listcon">
                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber"><img className="stepimg check" src="img\check.svg" alt=""/></div>
                                </div>
                                <h2 className="step-title">tell us what you’re thankful for!</h2>
                            </div>

                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber">2</div>
                                </div>
                                <h2 className="step-title"> Show what you are thankful for</h2>
                            </div>

                            <div className="con">
                                <div className="step">
                                    <div className="stepnumber">3</div>
                                </div>
                                <h2 className="step-title"> get your custom music video!</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="body-con">
                    <br/>
                    <div className="current-step">
                        <div className="line-before"></div>
                        <div className="con step-con">
                            <div className="step">
                                <div className="stepnumber">2</div>
                            </div>
                        </div>
                        <div className="line-after"></div>
                    </div>



                    <h1 className="main-color">
show what you are <br/>
thankful for!
</h1>
<br/>

<br className="deskhidden"/>
<div id="uploadPhoto">
                        <p className="textcon ios">First, pick a photo that matches your text submission.</p>


                        <div id="item" className="hidden"></div>

                        <div className="flex-con">

                        <div id="rotate"  className="hidden next-button-con inline-but small " 
                                onClick={this.rotateImg} data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:RotateImg'>
    <div className="next-button">
        <div className="nexr-button-innercon">
            
            <div className="next-button-text file11-text"> Rotate </div>
        </div>
    </div>
</div>

<div className="next-button-con inline-but">
<label htmlFor="file-1" >
    <div className="next-button">
        <div className="nexr-button-innercon">
            <input type="file" name="file-1[]" id="file-1" onChange={this.showFile} className="inputfile inputfile-1" accept="image/*" 
                                data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:UploadImg'/>
            <label htmlFor="file-1" className="next-button-text file1-text"> Upload photo&hellip;</label>
        </div>
    </div>
    </label>
</div>


</div>  
<p/>


                        <div id="submitPhoto" className="next-button-con next hidden" onClick={this.submitPhoto}
                                data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:Step2-SubmitPhoto'>
                            <div className="line-before"></div>
                            <div className="next-button">
                                <div className="nexr-button-innercon">
                                    <div className="next-button-text">Upload Video</div>
                                    <div className="next-button-arrow"><img src="img/arrow-right.svg" alt=""/></div>
                                </div>
                            </div>
                            <div className="line-after"></div>
                        </div>
</div>





<br />


<div id="uploadVideo" className="hidden">     

<img src="/img/phoneRotationIcons.svg" alt="" className="inline-center"/>


<p className="textcon ios">Next, pick of a video of what makes you thankful. You can dance, lip sync, or just have fun!</p>


<div id="vid-inpuut" className="hidden"> 
                        <video muted playsInline id="videoFileOut"></video>
                       
                        </div>   
<div id="vid-inpuut"> 
                        <div className="next-button-con inline-but">
                        <label htmlFor="file-2" >
                            <div className="next-button">
                                <div className="nexr-button-innercon">
                                    <input type="file" name="file-2[]" id="file-2" onChange={this.validateVideoFile} className="hidden" accept="video/*;capture=camcorder" 
                                        data-amplify-analytics-on='click'
                                        data-amplify-analytics-name='click'
                                        data-amplify-analytics-attrs='attr:UploadVid'/>
                                    <label id="labelText" htmlFor="file-2" className="next-button-text file1-text"> Upload video&hellip;</label>
                                </div>
                            </div>
                            </label>
                        </div>
                        </div>
                        <p id="feedback" className="textcon small">Preferably a portrait / vertical video.
No more than 30 second length
</p>
<br/>
<br/>
                        <div id="submitVideo" className="next-button-con next hidden" onClick={this.submitVideo} 
                                data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:Step2-SubmitVideo'>
                            <div className="line-before"></div>
                            <div className="next-button">
                                <div className="nexr-button-innercon">
                                    <div className="next-button-text">Last steps</div>
                                    <div className="next-button-arrow"><img src="img/arrow-right.svg" alt=""/></div>
                                </div>
                            </div>
                            <div className="line-after"></div>
                        </div>
                     
                    
                       
                    <br/>
                </div>
                </div>
            </div>
        );
    }
}

Step2IOS.contextType = AppContext;
export default withRouter(Step2IOS);